import React, { useEffect, useState } from 'react';
import { Modal, Table, Spin, Typography } from 'antd';
import { fetchChunks } from '../../api/api';

const { Title } = Typography;

interface ChunkModalProps {
  show: boolean;
  onHide: () => void;
  document: {
    id: string;
    title: string;
    dateModified: string;
    status: string;
    metadata?: { key: string; value: string }[];
  };
}

interface Chunk {
  page_content: string;
  metadata: { [key: string]: string };
}

const ChunkModal: React.FC<ChunkModalProps> = ({ show, onHide, document }) => {
  const [chunks, setChunks] = useState<Chunk[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (show && document.id) {
      const fetchDocumentChunks = async () => {
        setLoading(true);
        setError(null);
        try {
          const fetchedChunks = await fetchChunks(document.id);
          setChunks(fetchedChunks);
        } catch (err) {
          setError("Failed to fetch chunks");
          console.error(err);
        } finally {
          setLoading(false);
        }
      };

      fetchDocumentChunks();
    }
  }, [show, document]);

  const documentInfoColumns = [
    {
      title: 'Field',
      dataIndex: 'field',
      key: 'field',
      width: '30%',
    },
    {
      title: 'Value',
      dataIndex: 'value',
      key: 'value',
    },
  ];

  const documentInfoData = [
    { key: '1', field: 'Title', value: document.title },
    { key: '2', field: 'Added On', value: document.dateModified },
    { key: '3', field: 'Status', value: document.status },
  ];

  return (
    <Modal
      title="Chunks of Data"
      open={show}
      onCancel={onHide}
      footer={null}
      width={800}
      centered
    >
      <Table
        columns={documentInfoColumns}
        dataSource={documentInfoData}
        pagination={false}
        bordered
        size="small"
        style={{ marginBottom: 24 }}
      />

      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <Spin size="large" />
        </div>
      ) : error ? (
        <p style={{ color: 'red' }}>{error}</p>
      ) : chunks.length > 0 ? (
        chunks.map((chunk, index) => (
          <div key={index} style={{ marginBottom: 24, padding: 16, border: '1px solid #f0f0f0', borderRadius: 8 }}>
            <Title level={5}>Chunk {index + 1}</Title>
            <p style={{ marginBottom: 12 }}>{chunk.page_content}</p>
            {chunk.metadata && (
              <div>
                <strong>Metadata:</strong>
                <ul style={{ marginTop: 8 }}>
                  {Object.entries(chunk.metadata).map(([key, value], metaIndex) => (
                    <li key={metaIndex}>
                      <strong>{key}:</strong> {value}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))
      ) : (
        <p>No chunks available.</p>
      )}
    </Modal>
  );
};

export default ChunkModal;
